export default "__VITE_ASSET__BOcX9YWn__"